import { CheckIcon, CopyIcon, KeyRoundIcon, MailCheckIcon } from "lucide-react";

import { Button, Modal, ModalFooter, Tooltip } from "@/modules/common/components";
import { MANAGEMENT_COMPANY_STATUS_OPTIONS, ManagementCompanyStatus } from "@/modules/common/types/ManagementCompanies.enum";
import { useState } from "react";
import { toast } from "react-toastify";

interface CompanyCreatedModalProps {
  open: boolean;
  ownerEmail?: string;
  isDemonstration?: boolean;
  onClose: () => void;
}

const PROVISIONING_STATUS_LABEL =
  MANAGEMENT_COMPANY_STATUS_OPTIONS.find((option) => option.value === String(ManagementCompanyStatus.PROVISIONING))?.label ??
  "Carregando...";

const CompanyCreatedModal = ({ open, ownerEmail, isDemonstration, onClose }: CompanyCreatedModalProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!ownerEmail) return;

    await navigator.clipboard.writeText(ownerEmail);
    toast.success("E-mail copiado!");
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Modal
      open={open}
      onOpenChange={(next) => {
        if (!next) onClose();
      }}
      title="Gestora cadastrada com sucesso!"
      description={
        isDemonstration
          ? "O representante principal entrará com a senha definida no cadastro e o e-mail abaixo:"
          : "Um código para redefinição de senha foi enviado para o e-mail do representante principal:"
      }
    >
      <div className="flex items-center gap-3 rounded-lg border border-ui-primary/20 bg-ui-hover px-4 py-3.5">
        {isDemonstration ? (
          <KeyRoundIcon className="shrink-0 text-ui-primary" size={24} />
        ) : (
          <MailCheckIcon className="shrink-0 text-ui-primary" size={24} />
        )}
        <Tooltip label={ownerEmail}>
          <p className="text-[17px] font-bold text-ui-primary truncate">{ownerEmail}</p>
        </Tooltip>

        <button
          type="button"
          onClick={handleCopy}
          aria-label="Copiar e-mail"
          className="shrink-0 cursor-pointer rounded-md p-1.5 text-ui-primary hover:bg-ui-primary/10"
        >
          {copied ? <CheckIcon size={18} /> : <CopyIcon size={18} />}
        </button>
      </div>

      {isDemonstration && (
        <div className="mt-3 flex items-start gap-3 rounded-lg border border-ui-border-muted px-4 py-3">
          <p className="text-[13px] text-ui-text-muted">
            Os dados de demonstração estão sendo criados agora. Até terminar, a gestora fica com o status{" "}
            <span className="font-semibold text-ui-primary">{PROVISIONING_STATUS_LABEL}</span> e o primeiro usuário ainda não consegue
            acessar.
          </p>
        </div>
      )}

      <ModalFooter>
        <Button label="OK" className="w-full" onClick={onClose} />
      </ModalFooter>
    </Modal>
  );
};

export default CompanyCreatedModal;
